import React, { useState } from "react";
import "../../../../../styles/ambassadorChallenge/breadCrumb.scss";
import CreateChallengeModal from "./CreateChallengeModal";
import { useAmbassadorChallengeContext } from "../../../../../contexts/AmbassadorChallengeContext";

function BreadCrumb() {
  const { changeView, view, setView } = useAmbassadorChallengeContext();
  const [open, setOpen] = useState(false);

  return (
    <div className="breadCrumb">
      <div className="links">
        <button
          className="link"
          onClick={() => {
            changeView("overview");
          }}
        >
          Ambassador Challenge
        </button>

          {view !=='overview' &&
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_11158_60536)">
            <path
              d="M7.5 5L12.5 10L7.5 15"
              stroke="#1F78D1"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_11158_60536">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>}

        {view !=='overview' &&
        <span>
          {view[0].toUpperCase() + view.slice(1)}
        </span>}
      </div>

      {view !=='manage' &&
      <div className="btns">
        <button
          className="manage"
          onClick={() => {
            setView("manage");
          }}
        >
          Manage
        </button>
        <button className="create" onClick={() => setOpen(true)}>Create challenge</button>
      </div>}

      {open && <CreateChallengeModal onClose={() => setOpen(false)} />}
    </div>
  );
}

export default BreadCrumb;
